import React, { Component } from "react";
import Switch from "react-switch";
import styles from "./Toggle.scss";
 
class Toggle extends Component {
 constructor(props) {
 super(props);
 this.state = { checked: false };
 this.handleChange = this.handleChange.bind(this);
 }
 
//  handleChange(checked) {
// this.props.handleMarketingPref(checked);
// this.setState({ checked });

 
// }
handleChange =checked =>{
    //this.props.handleMarket(checked);
    this.props.handleToggle(checked);
    checked ? window.aUtils.sendAAEvent("ToggleOn","criticalPeakPricing") : window.aUtils.sendAAEvent("ToggleOff","criticalPeakPricing");
    
}


render() {
 return (
 
 <label htmlFor="criticalPeakPricing">
 
 <Switch
 checked={this.state.checked || this.props.isToggleOn}
 onChange={this.handleChange}
 handleDiameter={22}
 height={30}
 width={70}
 borderRadius={15}
 onColor="#64A000"
 offColor="#E9EAEE"
 disabled={this.props.isDisabled}
 
 
uncheckedIcon={
    <div className={styles.Off}>Off</div>
   }
checkedIcon={<div className={styles.On}>On</div>
   }
 
 className="react-switch"
 id="criticalPeakPricing"
 />
</label>
 
 );
 }
}
export default Toggle;
